import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { FaFileDownload, FaFileAlt } from "react-icons/fa";
import Button from "../../components/Button/button";
import {
  Card,
  PageContainer,
  LoadingOverlay,
  LoadingGif,
  TitleAndButton,
  SummaryTableMainContainer,
  SummaryTableContainer,
  ManualPaymentTablecontainer,
} from "./styles";
import { FaFilterCircleDollar } from "react-icons/fa6";
import FecharCaixaModal from "../../components/FecharCaixaModal/FecharCaixaModal";
import loadSCGif from "../../assets/load_SC.gif"; 
import { useAuth } from "../../AuthContext/AuthContext";
import caixaService from "../../services/CaixaService";
import { AbrirCaixaDto, CaixaHistoricoDto } from "../../shared/dtos/Caixa.dto";
import { GetFinancialRecordDto } from "../../shared/dtos/FichaFinanceira.dto";
import AbrirCaixaModal from "../../components/AbrirCaixaModal/AbrirCaixaModal";
import Pagination from "../../components/Pagination/pagination";
import {
  BlueTitle,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  StyledHR,
  TextError,
} from "../../shared/styles/global.styles";
import FiltroDataModal from "../../components/FiltroDataModal/FiltroDataModal";
import { AiOutlineClear } from "react-icons/ai";
import { FaCashRegister } from "react-icons/fa6";
import { BiChevronLeft } from "react-icons/bi";
import {
  formatarData,
  formatarDataParaAPI,
  formatarDataCaixa,
} from "../../utils/dateUtils/dateUtils";
import { Badge } from "react-bootstrap";
import { ModulosEnum } from "../../shared/enum/modulos.enum";
import { PermissoesEnum } from "../../shared/enum/permicao.enum";
import { DatePickerInputContainer } from "../../components/Input/styles";
import DatePicker from "react-datepicker";
import { IoCloseSharp } from "react-icons/io5";
import { Label } from "../../components/Label/styles";
import FichaFinanceiraService from "../../services/FichaFinanceiraService";
import RelatorioPDF from "./RelatorioPDF";
import { pdf } from "@react-pdf/renderer";
import { formatCurrency } from "../../utils/formatCurrency/formatCurrency";
import {
  Table,
  TableContainer,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/Table/styles";
import SelectComponent from "../../components/Select/select";
import lotacaoService from "../../services/LotacaoService";
import { Lotacao } from "../../shared/interfaces/DadosFinanceirosInterface";
import { progressBarSwalAlert } from "../../components/ProgressBarSwalAlert/ProgressBarSwalAlert";
import { Colors } from "../../shared/colors/colors";
import requestInProgressService from "../../services/RequestInProgressService";

const CaixaPage: React.FC = () => {
  const { user, checkPermission } = useAuth();
  const editOnly = checkPermission(ModulosEnum.CAIXA, PermissoesEnum.ESCRITA);
  const [lotacoes, setLotacoes] = useState<Lotacao[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [dateRange, setDateRange] = useState<
    [Date | undefined, Date | undefined]
  >([undefined, undefined]);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const [historicoList, setHistoricoList] = useState<CaixaHistoricoDto[]>([]);
  const [caixaAtual, setCaixaAtual] = useState<CaixaHistoricoDto | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFiltroDataModalOpen, setIsFiltroDataModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filtroAtivo, setFiltroAtivo] = useState(false);
  const [filtroDataInicio, setFiltroDataInicio] = useState<string>("");
  const [filtroDataFinal, setFiltroDataFinal] = useState<string>("");
  const itemsPerPage = 10;
  const [isRequest, setIsRequest] = useState<boolean>(false);
  const [manualPayments, setManualPayments] = useState<GetFinancialRecordDto[]>(
    []
  );
  const [selectLotacao, setSelectLotacao] = useState<Lotacao>();
  const [summaryManualPayments, setSummaryManualPayments] = useState<
    {
      idFormaPagamento: number;
      formaPagamento: string;
      valorBoleto: number;
      valorAjuste: number;
      valorRecebido: number;
      totalParcelas: number;
    }[]
  >([]);

  const [showManualPayments, setShowManualPayments] = useState(false);
  const [fecharCaixaId, setFecharCaixaId] = useState<number | null>(null);
  const [statusCaixa, setStatusCaixa] = useState<
    "ABERTO" | "FECHADO" | "ANTIGO" | ""
  >("");
  const [blobAnalyticPDF, setBlobAnalyticPDF] = useState<Blob>();

  const handleLimparFiltro = async () => {
    try {
      setIsLoading(true);
      setIsRequest(true);
      setFiltroDataInicio("");
      setFiltroDataFinal("");
      setFiltroAtivo(false);
      setCurrentPage(1);
      await loadCaixaData(1);
    } catch (error) {
      console.error("Erro ao limpar filtro:", error);
      Swal.fire("Erro", "Não foi possível limpar o filtro", "error");
    } finally {
      setIsLoading(false);
      setIsRequest(false);
    }
  };

  // ID fixo do usuário para operações de caixa
  const USER_ID = 3;

  const handleFiltroData = async (dataInicio: string, dataFinal: string) => {
    try {
      setIsLoading(true);
      setIsRequest(true);

      // Formata as datas para o formato ISO com timezone correto
      const dataInicioFormatada = formatarDataParaAPI(dataInicio);
      const dataFinalFormatada = formatarDataParaAPI(dataFinal);

      // Armazena as datas do filtro no estado com o formato correto
      const dataInicioLocal = `${dataInicio}T00:00:00`;
      const dataFinalLocal = `${dataFinal}T00:00:00`;

      setFiltroDataInicio(dataInicioLocal);
      setFiltroDataFinal(dataFinalLocal);

      setCurrentPage(1);

      const response = await caixaService.getHistoricoPeriodo(
        dataInicioFormatada,
        dataFinalFormatada,
        1,
        itemsPerPage
      );

      if (!response || !response.success || !response.data) {
        throw new Error("Resposta inválida da API");
      }

      // Processa as datas recebidas da API
      const historicoProcessado = response.data.map((item) => ({
        ...item,
        dataAbertura: formatarData(item.dataAbertura, true),
        dataFechamento: item.dataFechamento
          ? formatarData(item.dataFechamento, true)
          : undefined,
      }));

      setHistoricoList(historicoProcessado);
      const totalPages = Math.ceil(response.total / itemsPerPage);
      setTotalPages(totalPages);
      setFiltroAtivo(true);
    } catch (error) {
      console.error("Erro ao filtrar por data:", error);
      const errorMessage =
        error instanceof Error ? error.message : "Erro desconhecido";
      Swal.fire({
        icon: "error",
        title: "Erro ao filtrar",
        text: errorMessage,
        allowOutsideClick: false,
      });
    } finally {
      setIsLoading(false);
      setIsRequest(false);
    }
  };

  const getCaixaAberto = async () => {
    try {
      const caixaAberto = await caixaService.getCaixaAtual();
      if (caixaAberto) {
        setCaixaAtual(caixaAberto);
        if (caixaAberto.dataFechamento) {
          setStatusCaixa("FECHADO");
        } else {
          const formatDataCaixa =
            caixaAberto.dataCaixa.split("T")[0] + "T00:00:00";
          const formatDataAtual =
            new Date().toISOString().split("T")[0] + "T00:00:00";
          if (formatDataCaixa >= formatDataAtual) {
            setStatusCaixa("ABERTO");
          } else {
            setStatusCaixa("ANTIGO");
            const dataCaixaAnterior = formatarDataCaixa(caixaAberto.dataCaixa);
            await Swal.fire({
              icon: "warning",
              title: "Atenção - Caixa anterior não fechado",
              html: `
            <p><strong>Existe um caixa de dia anterior que ainda não foi fechado!</strong></p>
            <p>Data do caixa aberto: ${dataCaixaAnterior}</p>
            <p>Por favor, feche o caixa do dia anterior antes de realizar novas operações.</p>
          `,
              confirmButtonText: "Entendi",
              allowOutsideClick: false,
            });
          }
        }
      } else {
        setCaixaAtual(null);
        setStatusCaixa("");
      }
    } catch (error) {
      console.error("Erro ao verificar estado do caixa:", error);
      Swal.fire(
        "Erro",
        "Não foi possível verificar o estado do caixa",
        "error"
      );
    }
  };

  const fetchLotacoes = async () => {
    try {
      const response = await lotacaoService.getAllLotacoes();
      setLotacoes(response);
    } catch (error) {
      Swal.fire({
        title: "Erro",
        text: "Erro ao buscar lotações. Por favor, tente novamente.",
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
  };

  const handlePageChange = async (newPage: number) => {
    if (newPage === currentPage) return;

    try {
      setIsLoading(true);
      setIsRequest(true);
      setCurrentPage(newPage);

      if (showManualPayments) {
        // Se estiver mostrando pagamentos manuais, usa a paginação específica
        // await fetchManualPayments(newPage);
      } else if (filtroAtivo && filtroDataInicio && filtroDataFinal) {
        // Se houver filtro ativo, usa as datas do filtro
        const dataInicioFormatada = formatarDataParaAPI(filtroDataInicio);
        const dataFinalFormatada = formatarDataParaAPI(filtroDataFinal);

        const response = await caixaService.getHistoricoPeriodo(
          dataInicioFormatada,
          dataFinalFormatada,
          newPage,
          itemsPerPage
        );

        if (!response || !response.success || !response.data) {
          throw new Error("Resposta inválida da API");
        }

        const historicoProcessado = response.data.map((item) => ({
          ...item,
          dataAbertura: formatarData(item.dataAbertura, true),
          dataFechamento: item.dataFechamento
            ? formatarData(item.dataFechamento, true)
            : undefined,
        }));

        setHistoricoList(historicoProcessado);
        const totalPages = Math.ceil(response.total / itemsPerPage);
        setTotalPages(Math.max(1, totalPages));
      } else {
        // Se não tiver filtro, carrega normalmente
        await loadCaixaData(newPage);
      }
    } catch (error) {
      console.error("Erro ao mudar de página:", error);
      Swal.fire({
        title: "Erro",
        text: "Não foi possível carregar os dados da página",
        icon: "error",
        allowOutsideClick: false,
      });
      setCurrentPage(currentPage); // Reverte para a página anterior em caso de erro
    } finally {
      setIsLoading(false);
      setIsRequest(false);
    }
  };

  const imprimirRelatorio = async (pdf: Blob) => {
    try {
      const url = URL.createObjectURL(pdf);
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.focus();
      }
      // Revoga a URL após um pequeno atraso
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      return;
    } catch (error) {
      console.error("Erro ao processar o PDF:", error);
    } finally {
      // Garante que o foco volte para a janela principal
      window.focus();
    }
  };

  const fetchManualPayments = async (
    dateInitial: Date,
    dateFinal: Date,
    idLotacao?: number
  ) => {
    try {
      setIsLoading(true);
      setIsRequest(true);
      const data = {
        dateInitial,
        dateFinal,
        idLotacao,
      };
      await FichaFinanceiraService.getManualPaymentsByPeriod(data)
        .then(async (responseRelatorio) => {
          if (responseRelatorio.success) {
            Swal.fire({
              title: "Processando solicitação",
              html: progressBarSwalAlert({
                currentProgress: 0,
                totalProgress: 0,
                color: Colors.primary,
                showProgressText: true,
              }),
              showConfirmButton: false,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });

            let stopLoopRelatorio = false;
            let getRequestInProgressRelatorio =
              await requestInProgressService.getRequestInProgressById(
                responseRelatorio.data.id
              );
            await new Promise((resolve) => setTimeout(resolve, 2000));

            while (!stopLoopRelatorio) {
              getRequestInProgressRelatorio =
                await requestInProgressService.getRequestInProgressById(
                  responseRelatorio.data.id
                );

              if (getRequestInProgressRelatorio.finished) {
                stopLoopRelatorio = true;
              } else {
                Swal.update({
                  html: progressBarSwalAlert({
                    currentProgress:
                      getRequestInProgressRelatorio.currentProgress,
                    totalProgress: getRequestInProgressRelatorio.totalProgress,
                    color: Colors.primary,
                    showProgressText: true,
                    progressText: "Gerando relatório aguarde...",
                  }),
                });
                await new Promise((resolve) => setTimeout(resolve, 2000));
              }
            }
            if (!getRequestInProgressRelatorio.error) {
              // Se o status da resposta for 'sucesso', exibe uma mensagem de sucesso
              if (getRequestInProgressRelatorio.responseData) {
                const relatorioData: any | undefined = JSON.parse(
                  getRequestInProgressRelatorio.responseData
                );
                if (relatorioData) {
                  setManualPayments(relatorioData.result);
                  setSummaryManualPayments(relatorioData.summaryPayment);
                  const getPdfAnalytic = await fetch(
                    `${process.env.REACT_APP_API_URL}pdfs/${relatorioData.fileName}`
                  );
                  if (!getPdfAnalytic.ok) {
                    throw new Error(
                      `Erro ao buscar o PDF: ${getPdfAnalytic.statusText}`
                    );
                  }
                  const pdfBlobAnalytic = await getPdfAnalytic.blob();
                  setBlobAnalyticPDF(pdfBlobAnalytic);

                  await FichaFinanceiraService.deleteFileInPdfs(
                    relatorioData.fileName
                  );
                  setShowManualPayments(true);
                  Swal.fire({
                    icon: "success",
                    title: "Sucesso",
                    text: "Relatório gerado com sucesso!",
                    showCancelButton: true,
                    confirmButtonText: "Imprimir",
                    cancelButtonText: "Fechar",
                    allowOutsideClick: false,
                  }).then((willPrint) => {
                    if (willPrint.isConfirmed) {
                      imprimirRelatorio(pdfBlobAnalytic);
                      closeModal();
                    }
                  });
                }
              } else {
                const relatorioData: any | undefined =
                  getRequestInProgressRelatorio.responseData;
                const resultDeleteFile =
                  await FichaFinanceiraService.deleteFileInPdfs(
                    relatorioData.fileName
                  );
                if (resultDeleteFile.success) {
                  Swal.fire({
                    title: "Erro",
                    text: getRequestInProgressRelatorio.message,
                    icon: "error",
                    confirmButtonText: "OK",
                    allowOutsideClick: false,
                  });
                }
              }
            } else {
              Swal.fire({
                title: "Erro",
                text: "Ocorreu um erro ao solicitar o relatório de baixas manuais. Por favor, tente novamente.",
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false,
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro ao gerar relatório",
              text: "Ocorreu um erro ao solicitar o relatório de baixas manuais. Por favor, tente novamente.",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
          }
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({
            icon: "error",
            title: "Erro ao gerar relatório",
            text:
              error.response?.data?.message ||
              "Erro ao gerar relatório de baixas manuais",
            allowOutsideClick: false,
          });
        });
    } catch (error) {
      console.error("Erro ao buscar pagamentos manuais:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível carregar os pagamentos manuais. Tente novamente.",
        allowOutsideClick: false,
      });
    } finally {
      setIsLoading(false);
      setIsRequest(false);
      closeModal();
    }
  };

  const handleManualPaymentsClick = async () => {
    try {
      if (showManualPayments) {
        setShowManualPayments(false);
        setCurrentPage(1);
        loadCaixaData(1);
      } else {
        if (
          (!dateRange[0] && !dateRange[1]) ||
          !dateRange[0] ||
          !dateRange[1]
        ) {
          setInvalidFields(["dataVencimento"]);
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Selecione um período válido.",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
          return;
        }
        if (dateRange[0] > dateRange[1]) {
          setInvalidFields(["dataVencimento"]);
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "A data final não pode ser menor que a data inicial.",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
          return;
        }
        Swal.fire({
          title: "Gerando relatório...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        await fetchManualPayments(
          dateRange[0],
          dateRange[1],
          selectLotacao?.id
        );
      }
    } catch (error) {
      console.error("Erro ao carregar pagamentos manuais:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível carregar os pagamentos manuais. Tente novamente.",
        allowOutsideClick: false,
      });
    }
  };

  const renderManualPaymentsTable = () => {
    if (!showManualPayments) return null;

    // Agrupa os pagamentos por contribuinte
    const paymentsByContribuinte = manualPayments.reduce((acc, payment) => {
      const contribuinteId = payment.contribuinte?.id || "sem-contribuinte";
      if (!acc[contribuinteId]) {
        acc[contribuinteId] = {
          contribuinte: payment.contribuinte,
          payments: [],
        };
      }
      acc[contribuinteId].payments.push(payment);
      return acc;
    }, {} as Record<string | number, { contribuinte: any; payments: typeof manualPayments }>);

    return (
      <Card>
        <ManualPaymentTablecontainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableHeader>Contribuinte</TableHeader>
                <TableHeader>Nosso número</TableHeader>
                <TableHeader>Data de vencimento</TableHeader>
                <TableHeader>Data de pagamento</TableHeader>
                <TableHeader>Valor boleto</TableHeader>
                <TableHeader>Valor ajuste</TableHeader>
                <TableHeader>Valor Pago</TableHeader>
              </TableRow>
            </TableHead>
            <tbody>
              {Object.entries(paymentsByContribuinte).map(
                ([contribuinteId, { contribuinte, payments }]) => (
                  <>
                    {payments.map((payment, index) => (
                      <TableRow key={index}>
                        <TableData>{contribuinte.nome}</TableData>
                        <TableData>{payment.nossoNumero}</TableData>
                        <TableData>
                          {formatarData(payment.dataVencimento)}
                        </TableData>
                        <TableData>
                          {formatarData(payment.dataPagamento)}
                        </TableData>
                        <TableData>
                          {formatCurrency(payment.valorParcela)}
                        </TableData>
                        <TableData>
                          {formatCurrency(payment.valorAjuste)}
                        </TableData>
                        <TableData>
                          {formatCurrency(payment.valorPago)}
                        </TableData>
                      </TableRow>
                    ))}
                  </>
                )
              )}

              <TableRow>
                <TableData colSpan={4}></TableData>
                <TableData style={{ fontWeight: "bold" }}>
                  {formatCurrency(
                    manualPayments
                      .reduce(
                        (sum, payment) =>
                          sum +
                          (payment.valorParcela
                            ? Number(payment.valorParcela)
                            : 0),
                        0
                      )
                      .toString()
                  )}
                </TableData>
                <TableData style={{ fontWeight: "bold" }}>
                  {formatCurrency(
                    manualPayments
                      .reduce(
                        (sum, payment) =>
                          sum +
                          (payment.valorAjuste
                            ? Number(payment.valorAjuste)
                            : 0),
                        0
                      )
                      .toString()
                  )}
                </TableData>
                <TableData style={{ fontWeight: "bold" }}>
                  {formatCurrency(
                    manualPayments
                      .reduce(
                        (sum, payment) =>
                          sum +
                          (payment.valorPago ? Number(payment.valorPago) : 0),
                        0
                      )
                      .toString()
                  )}
                </TableData>
              </TableRow>
            </tbody>
          </Table>
          <SummaryTableMainContainer>
            <SummaryTableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableHeader>Forma de pagamento</TableHeader>
                    <TableHeader>Quantidade</TableHeader>
                    <TableHeader>Valor boleto</TableHeader>
                    <TableHeader>Valor ajuste</TableHeader>
                    <TableHeader>Valor recebido</TableHeader>
                  </TableRow>
                </TableHead>

                <tbody>
                  {summaryManualPayments.map((payment, index) => (
                    <TableRow key={index}>
                      <TableData>{payment.formaPagamento}</TableData>
                      <TableData>{payment.totalParcelas}</TableData>
                      <TableData>
                        {formatCurrency(payment.valorBoleto.toString())}
                      </TableData>
                      <TableData>
                        {formatCurrency(payment.valorAjuste.toString())}
                      </TableData>
                      <TableData>
                        {formatCurrency(payment.valorRecebido.toString())}
                      </TableData>
                    </TableRow>
                  ))}
                </tbody>
              </Table>
            </SummaryTableContainer>
          </SummaryTableMainContainer>

          {manualPayments.length === 0 && (
            <div style={{ textAlign: "center", padding: "2rem" }}>
              Nenhum pagamento manual encontrado
            </div>
          )}
        </ManualPaymentTablecontainer>
      </Card>
    );
  };

  const gerarRelatorioBaixaManual = async (
    data: GetFinancialRecordDto[],
    summary: {
      idFormaPagamento: number;
      formaPagamento: string;
      valorBoleto: number;
      valorAjuste: number;
      valorRecebido: number;
      totalParcelas: number;
    }[],
    dateInitial: string,
    dateFinal: string
  ) => {
    try {
      const blob = await pdf(
        <RelatorioPDF
          data={data}
          summaryPayment={summary}
          dateInitial={dateInitial}
          dateFinal={dateFinal}
        />
      ).toBlob();
      const url = URL.createObjectURL(blob);
      window.open(url);
    } catch (error: any) {
      console.error("Erro ao gerar relatório:", error);
      Swal.fire({
        icon: "error",
        title: "Erro ao gerar relatório",
        text:
          error.message ||
          "Não foi possível gerar o relatório. Tente novamente.",
        allowOutsideClick: false,
      });
    } finally {
      setIsLoading(false);
      setIsRequest(false);
    }
  };
  // Adicionar essa função para verificar caixa do dia anterior
  const verificarCaixaDiaAnterior = async () => {
    try {
      const verificacao = await caixaService.verificarCaixaDiaAnteriorAberto();

      if (verificacao.existeCaixaAnteriorAberto && verificacao.caixaAnterior) {
        // Formata a data do caixa anterior para exibição
        const dataCaixaAnterior = formatarDataCaixa(
          verificacao.caixaAnterior.dataCaixa
        );

        setStatusCaixa("ANTIGO");
        // Mostra alerta ao usuário
        await Swal.fire({
          icon: "warning",
          title: "Atenção - Caixa anterior não fechado",
          html: `
            <p><strong>Existe um caixa de dia anterior que ainda não foi fechado!</strong></p>
            <p>Data do caixa aberto: ${dataCaixaAnterior}</p>
            <p>Por favor, feche o caixa do dia anterior antes de realizar novas operações.</p>
          `,
          confirmButtonText: "Entendi",
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error("Erro ao verificar caixa do dia anterior:", error);
    }
  };

  const loadData = async () => {
    try {
      setIsLoading(true);
      setIsRequest(true);
      await getCaixaAberto();
      await loadCaixaData(currentPage);
    } catch (error) {
      console.error("Erro ao carregar dados:", error);
      Swal.fire("Erro", "Não foi possível carregar os dados iniciais", "error");
    } finally {
      setIsLoading(false);
      setIsRequest(false);
    }
  };

  const loadCaixaData = async (currentPage: number) => {
    try {
      setIsLoading(true);
      setIsRequest(true);
      const response = await caixaService.getHistoricoByPage(
        currentPage,
        itemsPerPage
      );

      // Garante que temos dados válidos
      if (
        !response ||
        !response.success ||
        !response.data ||
        response.data.length === 0
      ) {
        setHistoricoList([]);
        setCaixaAtual(null);
        setStatusCaixa("");

        setTotalPages(0);
        return;
      }

      // Processa as datas recebidas da API
      const historicoProcessado = response.data.map((item) => ({
        ...item,
        dataAbertura: formatarData(item.dataAbertura, true),
        dataFechamento: item.dataFechamento
          ? formatarData(item.dataFechamento, true)
          : undefined,
      }));

      setHistoricoList(historicoProcessado);
      // Atualiza o total de páginas baseado no total de registros retornado pela API
      const totalPages = Math.ceil(response.total / itemsPerPage);
      setTotalPages(totalPages);
    } catch (error) {
      console.error("Erro ao carregar histórico:", error);
      throw error;
    } finally {
      setIsLoading(false);
      setIsRequest(false);
    }
  };

  const handleFecharCaixa = (id: number) => {
    if (!user) {
      throw new Error("Usuário não autenticado");
    }
    setFecharCaixaId(id);
  };

  const handleConfirmFecharCaixa = async (valorFechamento: number) => {
    try {
      if (!fecharCaixaId) return;

      setIsLoading(true);
      setIsRequest(true);
      const response = await caixaService.fecharCaixa(
        fecharCaixaId,
        valorFechamento,
        USER_ID
      );

      // Limpa o caixa atual
      setCaixaAtual(response);
      setStatusCaixa("FECHADO");
      setFecharCaixaId(null);

      // Busca o histórico atualizado
      await loadCaixaData(currentPage);

      // Mostra mensagem de sucesso
      await Swal.fire({
        icon: "success",
        title: "Sucesso",
        text: "Caixa fechado com sucesso!",
        allowOutsideClick: false,
      });
    } catch (error) {
      console.error("Erro ao fechar caixa:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Erro ao fechar o caixa. Tente novamente.",
        allowOutsideClick: false,
      });
    } finally {
      setIsLoading(false);
      setIsRequest(false);
    }
  };

  const handleAbrirCaixa = async (valorAbertura: number, dataCaixa: Date) => {
    try {
      // Verifica se há usuário logado
      if (!user) {
        throw new Error("Usuário não autenticado");
      }

      // Mostra loading
      setIsLoading(true);
      setIsRequest(true);
      // Verifica se existe caixa do dia anterior aberto
      const verificacao = await caixaService.verificarCaixaDiaAnteriorAberto();

      if (verificacao.existeCaixaAnteriorAberto && verificacao.caixaAnterior) {
        setIsLoading(false);
        setIsRequest(false);
        // Formata a data do caixa anterior para exibição
        const dataCaixaAnterior = formatarDataCaixa(
          verificacao.caixaAnterior.dataCaixa
        );

        // Mostra alerta ao usuário
        await Swal.fire({
          icon: "warning",
          title: "Atenção - Caixa anterior aberto",
          html: `
            <p><strong>Existe um caixa anterior aberto que precisa ser fechado!</strong></p>
            <p>Data do caixa aberto: ${dataCaixaAnterior}</p>
            <p>Por favor, feche o caixa do dia anterior antes de abrir um novo.</p>
          `,
          confirmButtonText: "Entendi",
          allowOutsideClick: false,
        });
        loadData();
        return; // Interrompe a abertura de um novo caixa
      }

      const dados: AbrirCaixaDto = {
        dataCaixa: dataCaixa.toISOString(),
        valorAbertura: valorAbertura,
        idUserAbertura: USER_ID,
      };

      const response = await caixaService.abrirCaixa(dados);

      // Atualiza o estado
      setCaixaAtual(response);
      setStatusCaixa("ABERTO");

      // Busca o histórico atualizado
      await loadCaixaData(currentPage);

      // Mostra mensagem de sucesso
      await Swal.fire({
        icon: "success",
        title: "Sucesso",
        text: "Caixa aberto com sucesso!",
        allowOutsideClick: false,
      });
    } catch (error: any) {
      console.error("Erro ao abrir caixa:", error);
      await Swal.fire({
        icon: "error",
        title: "Erro ao abrir caixa",
        allowOutsideClick: false,
        text:
          error.message ||
          "Não foi possível abrir o caixa. Por favor, tente novamente.",
      });
    } finally {
      setIsLoading(false);
      setIsRequest(false);
    }
  };

  const renderHistoricoItem = (caixa: CaixaHistoricoDto) => {
    return (
      <TableRow key={caixa.id}>
        <TableData>{formatarData(caixa.dataCaixa)}</TableData>
        <TableData>
          <Badge
            bg={
              caixa.dataFechamento
                ? "rgba(220, 53, 69, 0.5)"
                : "rgba(40, 167, 69, 0.6)"
            }
            style={{
              width: "auto",
              textAlign: "center",
              display: "inline-block",
              padding: "10px 10px",
              fontSize: "1rem",
              color: "rgba(0, 0, 0, 0.5)",
              backgroundColor: caixa.dataFechamento
                ? "rgba(220, 53, 69, 0.5)"
                : "rgba(40, 167, 69, 0.6)",
              border: "none",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            {caixa.dataFechamento ? "Fechado" : "Aberto"}
          </Badge>
        </TableData>
        {/* <TableData>{formatCurrency(caixa.valorAbertura)}</TableData>
        <TableData>
          {caixa.valorFechamento ? formatCurrency(caixa.valorFechamento) : "-"}
        </TableData> */}
        <TableData>
          {caixa.valorMovimentacao
            ? formatCurrency(caixa.valorMovimentacao.toString())
            : "R$ 0,00"}
        </TableData>
      </TableRow>
    );
  };

  const renderCaixaAtual = (caixa: CaixaHistoricoDto) => {
    if (!caixa) {
      return null;
    }

    // Formatar a data e hora do caixa usando a função específica do caixa
    // Que já lida corretamente com o timezone
    let dataHoraAbertura = formatarDataCaixa(caixa.dataCaixa);

    let dataHoraFechamento = caixa.dataFechamento
      ? formatarDataCaixa(caixa.dataFechamento)
      : undefined;

    if (
      dataHoraAbertura === "Data não disponível" ||
      dataHoraAbertura === "Data inválida" ||
      dataHoraAbertura === "Erro ao formatar data"
    ) {
      console.error("Erro ao formatar data do caixa:", caixa.dataCaixa);
      dataHoraAbertura = "Data não disponível";
    }

    const statusText =
      statusCaixa === "FECHADO"
        ? "Fechado"
        : statusCaixa === "ABERTO"
        ? "Aberto"
        : statusCaixa === "ANTIGO"
        ? "Aguardando Fechamento"
        : "Carregando status ...";

    const statusColor =
      statusCaixa === "FECHADO"
        ? "rgba(220, 53, 69, 0.5)"
        : statusCaixa === "ABERTO"
        ? "rgba(40, 167, 69, 0.5)"
        : statusCaixa === "ANTIGO"
        ? "rgba(255, 200, 20, 0.5)"
        : "rgba(135, 206, 235, 0.5)";

    return (
      <div
        style={{
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          padding: "15px 20px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          margin: "20px 0",
          width: "100%",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "15px" }}>
          <h2
            style={{
              fontSize: "1.5rem",
              margin: "0",
              fontWeight: "500",
              color: "#333",
            }}
          >
            Controle de caixa
          </h2>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "80px",
          }}
        >
          <div>
            <strong>Caixa do dia:</strong>&nbsp;
            <span style={{ color: "#2563EB" }}>{dataHoraAbertura}</span>
          </div>
          {caixa.dataFechamento && dataHoraFechamento && (
            <div>
              <strong>Fechado:</strong>&nbsp;
              <span style={{ color: "#2563EB" }}>{dataHoraFechamento}</span>
            </div>
          )}
          <div>
            <strong>Status:</strong>&nbsp;
            <Badge
              style={{
                width: "auto",
                textAlign: "center",
                display: "inline-block",
                padding: "10px 10px",
                color: "rgba(0, 0, 0, 0.5)",
                fontSize: "1rem",
                backgroundColor: statusColor,
                border: "none",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
              bg={statusColor}
            >
              {statusText}
            </Badge>
          </div>
          <div>
            <strong>Valor de movimentação:</strong>&nbsp;
            <span style={{ color: "#2563EB" }}>
              {formatCurrency(caixa.valorMovimentacao || "0")}
            </span>
          </div>
          {/* <div>
            <strong>Valor abertura:</strong>&nbsp;
            <span style={{ color: "#2563EB" }}>
              {formatCurrency(caixa.valorAbertura)}
            </span>
          </div> */}
          {/* {!!caixa.valorFechamento && caixa.dataFechamento && (
            <div>
              <strong>Valor fechamento:</strong>&nbsp;
              <span style={{ color: "#2563EB" }}>
                {formatCurrency(caixa.valorFechamento.toString())}
              </span>
            </div>
          )} */}
          {!caixa.dataFechamento && editOnly && (
            <Button
              schemaButton="full-primary"
              style={{
                padding: "8px 15px",
                color: "white",
                border: "none",
                borderRadius: "5px",
                fontSize: "0.9rem",
              }}
              action={() => handleFecharCaixa(caixa.id)}
            >
              Fechar caixa
            </Button>
          )}
        </div>
      </div>
    );
  };

  const handleDateRangeChange = (dates: [Date | null, Date | null]) => {
    // Convertendo valores null para undefined
    const [start, end] = dates;

    if (start) {
      setDateRange([start, dateRange[1]]);
    }
    if (end) {
      setDateRange([dateRange[0], end]);
    }
  };

  const closeModal = () => {
    setInvalidFields([]);
    setSelectLotacao(undefined);
    setDateRange([undefined, undefined]);
    setShowModal(false);
    setIsLoading(false);
    setIsRequest(false);
  };

  // Função para formatar a entrada manual de datas
  const handleDateInputChange = (e: any) => {
    if (!e || !e.target || typeof e.target.value !== "string") return;

    let value = e.target.value;

    // Não fazer nada se o campo estiver vazio
    if (!value) return;

    // Verificar se o valor contém hífen (separando intervalo de datas)
    const parts = value.split("-");

    if (parts.length > 1) {
      // Processar intervalo de datas (início - fim)
      let startDate = parts[0].trim();
      let endDate = parts[1].trim();

      // Formatar a primeira data
      startDate = formatDateInput(startDate);

      // Formatar a segunda data
      endDate = formatDateInput(endDate);

      // Recompor o valor com o formato correto
      e.target.value = `${startDate} - ${endDate}`;
    } else {
      // Processar uma única data
      const formattedDate = formatDateInput(value);

      // Verificar se a primeira data está completa (10 caracteres = dd/mm/aaaa)
      // Se estiver completa e não for uma operação de apagar (verificar se o valor atual é maior que o anterior)
      if (formattedDate.length === 10 && value.length >= formattedDate.length) {
        // Adicionar o hífen automaticamente
        e.target.value = `${formattedDate} - `;
      } else {
        e.target.value = formattedDate;
      }
    }
  };

  // Função auxiliar para formatar uma data individual
  const formatDateInput = (value: string): string => {
    // Remover caracteres não numéricos
    let numbers = value.replace(/\D/g, "");

    // Limitar a 8 dígitos (ddmmyyyy)
    numbers = numbers.substring(0, 8);

    // Aplicar máscara dd/mm/yyyy
    let formattedValue = "";
    if (numbers.length > 0) {
      formattedValue = numbers.substring(0, Math.min(2, numbers.length));

      if (numbers.length > 2) {
        formattedValue +=
          "/" + numbers.substring(2, Math.min(4, numbers.length));
      }

      if (numbers.length > 4) {
        formattedValue +=
          "/" + numbers.substring(4, Math.min(8, numbers.length));
      }
    }

    return formattedValue;
  };

  useEffect(() => {
    loadData();
    fetchLotacoes();
  }, []);

  return (
    <PageContainer>
      {isLoading && (
        <LoadingOverlay>
          <LoadingGif src={loadSCGif} alt="Carregando..." />
        </LoadingOverlay>
      )}

      <FecharCaixaModal
        isOpen={fecharCaixaId !== null}
        onClose={() => setFecharCaixaId(null)}
        onConfirm={handleConfirmFecharCaixa}
      />

      <AbrirCaixaModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={(valorAbertura, dataCaixa) =>
          handleAbrirCaixa(valorAbertura, dataCaixa)
        }
      />

      {caixaAtual && renderCaixaAtual(caixaAtual)}

      <TitleAndButton>
        <BlueTitle>
          {showManualPayments
            ? "Relatório de Baixas Manuais"
            : "Histórico de Caixa"}
        </BlueTitle>

        <div style={{ display: "flex", gap: "10px" }}>
          {(!caixaAtual || caixaAtual?.dataFechamento) && editOnly && (
            <Button
              schemaButton="full-primary"
              action={() => setIsModalOpen(true)}
              disabled={showManualPayments || filtroAtivo} // Desabilita quando há pagamentos manuais ou filtro ativo
            >
              <FaCashRegister size={20} style={{ marginRight: 5 }} />
              Abrir Caixa
            </Button>
          )}
          <Button
            schemaButton="full-primary"
            action={() => {
              showManualPayments
                ? (() => {
                    setShowManualPayments(false);
                    setDateRange([undefined, undefined]);
                  })()
                : setShowModal(true);
            }}
            disabled={filtroAtivo} // Desabilita quando o filtro está ativo
          >
            {showManualPayments ? (
              <BiChevronLeft style={{ fontSize: "2rem" }} />
            ) : (
              <FaFileAlt size={20} style={{ marginRight: 5 }} />
            )}
            {showManualPayments ? "Voltar" : "Relatório de Baixas Manuais"}
          </Button>
          <Button
            schemaButton="full-primary"
            action={() => setIsFiltroDataModalOpen(true)}
            disabled={showManualPayments} // Disable when showing manual payments or when cash register is open
          >
            <FaFilterCircleDollar size={20} style={{ marginRight: 5 }} />
            Filtro por Data
          </Button>
          {filtroAtivo && (
            <Button schemaButton="full-primary" action={handleLimparFiltro}>
              <AiOutlineClear size={20} />
              Limpar Filtro
            </Button>
          )}
          {showManualPayments && blobAnalyticPDF && (
            <Button
              schemaButton="full-primary"
              action={() => imprimirRelatorio(blobAnalyticPDF)}
            >
              <FaFileDownload />
              Imprimir relatório
            </Button>
          )}
        </div>
      </TitleAndButton>
      <StyledHR />
      {filtroAtivo && filtroDataInicio && filtroDataFinal && (
        <div
          style={{
            fontSize: "1.1em",
          }}
        >
          <span style={{ color: "#000" }}>
            Registros filtrados no período:{" "}
          </span>
          <span style={{ color: "#0066cc", fontWeight: "bold" }}>
            {formatarData(filtroDataInicio)} até {formatarData(filtroDataFinal)}
          </span>
        </div>
      )}

      {!showManualPayments ? (
        <>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeader>Data</TableHeader>
                  <TableHeader>Status</TableHeader>
                  {/* <TableHeader>Abertura</TableHeader>
                  <TableHeader>Fechamento</TableHeader> */}
                  <TableHeader>Movimento</TableHeader>
                </TableRow>
              </TableHead>
              <tbody>
                {historicoList.map((item) => renderHistoricoItem(item))}
                {historicoList.length === 0 && (
                  <TableRow>
                    <TableData colSpan={5} style={{ textAlign: "center" }}>
                      Nenhum registro encontrado
                    </TableData>
                  </TableRow>
                )}
              </tbody>
            </Table>
          </TableContainer>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </>
      ) : (
        renderManualPaymentsTable()
      )}

      <FiltroDataModal
        isOpen={isFiltroDataModalOpen}
        onClose={() => setIsFiltroDataModalOpen(false)}
        onConfirm={handleFiltroData}
      />
      <ModalContainer show={showModal}>
        <ModalContent style={{ marginTop: "-12%" }}  width={35}>
          <Button
            type="button"
            schemaButton="x-close"
            action={() => closeModal()}
            icon={<IoCloseSharp size={30} />}
            position="absolute"
            top={10}
            right={10}
          />
          <ModalHeader>
            <BlueTitle>Gerar relatório de recebimentos</BlueTitle>
          </ModalHeader>

          <ModalBody>
            <div>
              <Label htmlFor="lotacao">Lotação</Label>
              <SelectComponent
                color="black"
                placeholder="Todas as lotações"
                isPlaceHolder={false}
                id="lotacao"
                width={Number("100%")}
                name="lotacao"
                disabled={isRequest}
                value={selectLotacao?.id?.toString() ?? ""}
                onChange={(e) => {
                  if (e.target.value === "0") {
                    setSelectLotacao({ id: 0, descricao: "Sem Lotacao" });
                  } else {
                    const selectedLotacao = lotacoes.find(
                      (lotacao) => lotacao.id === parseInt(e.target.value)
                    );
                    setSelectLotacao(selectedLotacao);
                  }
                }}
                options={[
                  { value: "0", label: "Sem lotação" },
                  ...lotacoes.map((lotacao) => ({
                    value: lotacao.id!.toString(),
                    label: lotacao.descricao,
                  })),
                ]}
                // errorMessage={
                //   invalidFields.includes("lotacao")
                //     ? "A seleção da lotação é obrigatória"
                //     : ""
                // }
              />
            </div>
            <div>
              <Label className="filtro-label" htmlFor="dataVencimento">
                Selecione um período <TextError>*</TextError>
              </Label>
              <DatePickerInputContainer
                width={Number("100%")}
                hasIconLeft={false}
                hasIconRight={false}
                error={invalidFields.includes("dataVencimento") ? true : false}
                className={
                  dateRange[0] || dateRange[1] ? "has-date-content" : ""
                }
              >
                <DatePicker
                  selectsRange={true}
                  name="dataVencimento"
                  startDate={dateRange[0] as Date | undefined}
                  endDate={dateRange[1] as Date | undefined}
                  onChange={(dates) => {
                    handleDateRangeChange(dates as [Date | null, Date | null]);

                    setInvalidFields((prev) =>
                      prev.filter((field) => field !== "dataVencimento")
                    );
                  }}
                  onChangeRaw={handleDateInputChange}
                  calendarStartDay={0}
                  className={`date-picker-input placeholder-custom ${
                    dateRange[0] || dateRange[1] ? "has-value" : "no-value"
                  }`}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="00/00/0000 - 00/00/0000"
                  showPopperArrow={false}
                  popperPlacement="bottom-start"
                  isClearable={false}
                  showYearDropdown
                  showMonthDropdown
                  scrollableMonthYearDropdown
                  wrapperClassName={
                    dateRange[0] || dateRange[1]
                      ? "date-wrapper-filled"
                      : "date-wrapper-empty"
                  }
                  locale="pt-BR"
                  autoComplete="off"
                  allowSameDay
                  onKeyDown={(e) => {
                    if (e.key === "Delete" || e.key === "Backspace") {
                      setDateRange([undefined, undefined]);
                      return;
                    }
                  }}
                />
              </DatePickerInputContainer>
              {invalidFields.includes("dataVencimento") && (
                <TextError>Selecione um período corretamente</TextError>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              schemaButton="full-primary"
              action={() => {
                handleManualPaymentsClick();
              }}
              disabled={isRequest}
            >
              Gerar relatório
            </Button>
          </ModalFooter>
        </ModalContent>
      </ModalContainer>
    </PageContainer>
  );
};

export default CaixaPage;
